import { type FC } from 'react';

interface UserAvatarProps {
  initials: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

const sizeClasses: Record<string, string> = {
  sm: 'w-7 h-7 text-xs',
  md: 'w-9 h-9 text-sm',
  lg: 'w-11 h-11 text-base',
};

const UserAvatar: FC<UserAvatarProps> = ({ initials, name, size = 'md', onClick }) => {
  return (
    <div
      onClick={onClick}
      title={name}
      className={`${sizeClasses[size]} rounded-full bg-primary-500 text-background-50 font-semibold flex items-center justify-center ${onClick ? 'cursor-pointer hover:bg-primary-600 transition-colors' : ''}`}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;